import { type DashRouteType, URL_PARTNER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_SEARCH_PLATFORM = `${URL_PARTNER_SCOPED}/search-platform`
const URL_SEARCH_PLATFORM_SEARCH_RESULTS = `${URL_SEARCH_PLATFORM}/search-results`
const URL_SEARCH_PLATFORM_CREATE = `${URL_SEARCH_PLATFORM_SEARCH_RESULTS}/create`
const URL_SEARCH_PLATFORM_EDIT = `${URL_SEARCH_PLATFORM_SEARCH_RESULTS}/:id/edit`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'search-platform'>
  | DashRouteType<'search-platform-search-results'>
  | DashRouteType<'search-platform-create'>
  | DashRouteType<'search-platform-edit'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'search-platform': URL_SEARCH_PLATFORM,
  'search-platform-search-results': URL_SEARCH_PLATFORM_SEARCH_RESULTS,
  'search-platform-create': URL_SEARCH_PLATFORM_CREATE,
  'search-platform-edit': URL_SEARCH_PLATFORM_EDIT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
